module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add a point","exemplary":"Exemplary","generate":"Generate","regenerate":"Regenerate"}}')
  delete Component.options._Ctor
}
